import React from "react";
import { link } from "./link";
import Auth from "../Auth";
import { Line } from "react-chartjs-2";
import axios from "axios";
class ChartOver extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      months: [],
    };
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.getMonthlyChart();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getMonthlyChart = async () => {
    try {
      const response = await axios.post(
        `${link()}&do=getmonthlychart&ra=round&ft=rec&id=${encodeURIComponent(this.props.roundId || "")}`,
        {},
        { timeout: 30000 }
      );
      const data = response.data;
      if (this.mounted && data && data.available === true && Array.isArray(data.months)) {
        this.setState({ months: data.months });
      }
    } catch (error) {
      console.log(error);
      Auth.handleHttpCodes(error, "chartOver");
    }
  };

  render() {
    const { months } = this.state;
    const labels = months.map((row) => row.month);
    const paiddata = months.map((row) => Number(row.paid));
    const topaydata = months.map((row) => Number(row.topay));

    const config = {
      labels,

      datasets: [
        {
          label: "Contribution",
          data: paiddata,
          fill: true,
          backgroundColor: " #16977f",
        },
        {
          label: "Expected Payments",
          data: topaydata,
          fill: true,
          backgroundColor: "#DFE0EB",
        },
      ],
    };
    const legend = {
      display: true,
      position: "bottom",
    };
    // Chart.js v3 options; a fixed-height container plus maintainAspectRatio:false keeps the plot readable on phones.
    const compact = (value) => {
      const number = Number(value);
      if (Math.abs(number) >= 1e6) return `${Number((number / 1e6).toFixed(2))}M`;
      if (Math.abs(number) >= 1e3) return `${Number((number / 1e3).toFixed(2))}k`;
      return number;
    };
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: { legend },
      scales: {
        x: { ticks: { maxRotation: 60, autoSkip: true } },
        y: { beginAtZero: true, ticks: { callback: compact } },
      },
    };

    return (
      <div className="chart">
        <Line data={config} options={options} />
      </div>
    );
  }
}

export default ChartOver;
